module.exports = __webpack_public_path__ + "static/media/01.Krishna.bdcd54f6.jpg";